// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"ea4ba64f","34":"0873e761","189":"3435b44c","287":"15c27dd7","346":"92befa31","951":"cbfa838c"}[chunkId] + ".chunk.js";
};